import { render, staticRenderFns } from "./Plugin.vue?vue&type=template&id=0fbb78e4&scoped=true"
import script from "./Plugin.vue?vue&type=script&lang=ts"
export * from "./Plugin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbb78e4",
  null
  
)

export default component.exports